document.addEventListener("DOMContentLoaded", () => {
  const appointmentForm = document.querySelector(".appointment-form form");
  if (!appointmentForm) return;

  const inputTime = document.querySelector(".js-preferred-time");
  const inputDate = document.querySelector(".js-preferred-date");
  const textarea = document.querySelector(".js-form-message");

  const locationInputs = document.querySelectorAll('input[name="PreferredLocation"]');
  const errorEl = document.querySelector(".js-location-error");
  const contactTagEl = document.getElementById("ContactTag");

  const getSelectedLocation = () => {
    const checked = [...locationInputs].find(r => r.checked);
    return checked ? checked.value : null;
  };

  const upsertHeaderInTextarea = () => {
    if (!textarea) return;

    const timeValue = inputTime?.value?.trim() || "-";
    const dateValue = inputDate?.value?.trim() || "-";

    const newHeader =
      `Preferred date: ${dateValue}\n` +
      `Preferred time: ${timeValue}\n\n`;

    const text = textarea.value || "";
    const headerRegex = /^Preferred date:.*?\nPreferred time:.*?\n\n/s;

    textarea.value = headerRegex.test(text)
      ? text.replace(headerRegex, newHeader)
      : newHeader + text;
  };

  // radio → ContactTag
  locationInputs.forEach(radio => {
    radio.addEventListener("change", function () {
      if (contactTagEl) contactTagEl.value = this.value;
      if (errorEl) errorEl.style.display = "none";
    });
  });

  // 1) Przechwyć SUBMIT (capture)
  appointmentForm.addEventListener("submit", (e) => {
    const selectedLocation = getSelectedLocation();

    if (!selectedLocation) {
      e.preventDefault();
      if (errorEl) errorEl.style.display = "block";
      return;
    }
    if (errorEl) errorEl.style.display = "none";

    upsertHeaderInTextarea();

    if (selectedLocation === "location2") {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // tu tylko przygotowanie danych – a wysyłkę zrobimy na click handlerze
      // (bo czasem ktoś robi form.submit() w click)
    }
  }, true);

  // 2) Przechwyć KLIK w submit button (capture) i zrób routing tu
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".js-form-button");
    if (!btn) return;

    const selectedLocation = getSelectedLocation();

    if (!selectedLocation) {
      e.preventDefault();
      if (errorEl) errorEl.style.display = "block";
      return;
    }

    if (selectedLocation !== "location2") return;

    // BLOKUJ wszystko inne co mogłoby submitować appointment-form
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    upsertHeaderInTextarea();

    const globoForm = document.querySelector(".globo-form-app form");
    if (!globoForm) return;

    const globoName  = document.getElementById("128764-text-1");
    const globoEmail = document.getElementById("128764-email");
    const globoPhone = document.getElementById("128764-phone-1");
    const globoMsg   = document.getElementById("128764-textarea");

    const srcName  = appointmentForm.querySelector('input[name="contact[name]"]');
    const srcEmail = appointmentForm.querySelector('input[name="contact[email]"]');
    const srcPhone = appointmentForm.querySelector('input[name="contact[phone]"]');

    if (globoName && srcName)   globoName.value  = srcName.value || "";
    if (globoEmail && srcEmail) globoEmail.value = srcEmail.value || "";
    if (globoPhone && srcPhone) globoPhone.value = srcPhone.value || "";
    if (globoMsg)               globoMsg.value   = textarea?.value || "";

    if (typeof globoForm.requestSubmit === "function") globoForm.requestSubmit();
    else globoForm.submit();

    setTimeout(() => {
      const title = document.querySelector('.message.success .gfb__content-title');
      const content = document.querySelector('.message.success .content');

      if (!title && !content) return;

      const text = [
        title?.innerText?.trim(),
        content?.innerText?.trim()
      ].filter(Boolean).join("\n\n");

      if (text) {
        alert(text);
      }
    }, 1000);
  }, true);
});
